// extracted by mini-css-extract-plugin
export default {"navbar":"NavMenu_navbar__8xKvC","tab":"NavMenu_tab__XWvPK","tabActive":"NavMenu_tabActive__zpjrO","tabDisabled":"NavMenu_tabDisabled__bIYKH"};